(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const moments = [
    /* Home: one product sequence and two editorial image wipes. */
    { selector: '.pcw-products .pcw-product', type: 'card', stagger: 70, limit: 6 },
    { selector: '.pcw-feature__visual', type: 'wipe-left' },
    { selector: '.pcw-intro__media', type: 'wipe-right' },
    { selector: '.pcw-media-feature__embed', type: 'poster' },

    /* Shop: movement follows the shopping story. */
    { selector: '.pcw-collection__shipping-truck', type: 'truck' },
    { selector: '.pcw-collection__filters', type: 'line' },
    { selector: '.pcw-collection__grid .pcw-product-card', type: 'card', stagger: 55, limit: 5 },
    { selector: '.pcw-collection__locator-copy', type: 'copy-left' },
    { selector: '.pcw-collection__locator-map', type: 'map' },

    /* Wine Club: plans settle in, then the bottles take the stage. */
    { selector: '.shopify-section--pcw-wine-club .pcw-club__benefit-grid .pcw-club__benefit', type: 'stat', stagger: 55, limit: 5 },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__plan', type: 'plan', stagger: 90, limit: 4 },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__plan-bottles .pcw-club__plan-bottle', type: 'bottle', stagger: 65, limit: 6 },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__experience-steps .pcw-club__experience-step', type: 'step', stagger: 75, limit: 4 },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__recipe-grid .pcw-club__recipe', type: 'poster', stagger: 80, limit: 3 },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__collage-item:nth-child(odd)', type: 'wipe-left' },
    { selector: '.shopify-section--pcw-wine-club .pcw-club__collage-item:nth-child(even)', type: 'wipe-right' },

    /* Meet Paul: alternating photographic chapter turns. */
    { selector: '.pcw-chapter:nth-of-type(odd) .pcw-chapter__media', type: 'wipe-left' },
    { selector: '.pcw-chapter:nth-of-type(even) .pcw-chapter__media', type: 'wipe-right' },
    { selector: '.pcw-chapters__manifesto', type: 'line' },

    /* Media: posters resolve into focus; the editorial image wipes in. */
    { selector: '.pcw-media__clips .pcw-media__clip', type: 'poster', stagger: 75, limit: 8 },
    { selector: '.pcw-media__story-media', type: 'wipe-right' },

    /* Events: calendar, date cards and the two halves of the ticket. */
    { selector: '.pcwe__calendar', type: 'calendar' },
    { selector: '.pcwe__events .pcwe__event', type: 'date', stagger: 70, limit: 6 },
    { selector: '.pcwe__ticket-main', type: 'ticket-left' },
    { selector: '.pcwe__ticket-stub', type: 'ticket-right' },

    /* Selector: the three Paul personas arrive as one deliberate beat. */
    { selector: '.pcw-somm__persona-grid .pcw-somm__persona', type: 'persona', stagger: 95, limit: 3 },

    /* Product recommendations: a single compact merchandising sequence. */
    { selector: '.shopify-section--product-recommendations product-card', type: 'card', stagger: 60, limit: 4 },
    { selector: '.shopify-section--product-recommendations .product-card', type: 'card', stagger: 60, limit: 4 }
  ];

  const reveal = element => {
    if (!element || element.classList.contains('pcw-motion-visible')) return;
    element.classList.add('pcw-motion-visible');
    observer?.unobserve(element);
  };

  const prepare = (scope = document) => {
    moments.forEach(moment => {
      const matches = [...scope.querySelectorAll(moment.selector)].slice(0, moment.limit || Infinity);
      matches.forEach((element, index) => {
        if (element.hasAttribute('data-pcw-motion')) return;
        element.setAttribute('data-pcw-motion', moment.type);
        if (moment.stagger) {
          element.style.setProperty('--pcw-motion-delay', `${index * moment.stagger}ms`);
        }
        if (reduceMotion.matches || !observer || element.closest('.shopify-section--selected')) {
          reveal(element);
        } else {
          observer.observe(element);
        }
      });
    });
  };

  const createObserver = () => {
    observer?.disconnect();
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      observer = null;
      return;
    }
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { threshold: .16, rootMargin: '0px 0px -6% 0px' });
  };

  const init = () => {
    if (!reduceMotion.matches) root.classList.add('pcw-motion-enabled');
    createObserver();
    prepare(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  reduceMotion.addEventListener?.('change', () => {
    root.classList.toggle('pcw-motion-enabled', !reduceMotion.matches);
    createObserver();
    document.querySelectorAll('[data-pcw-motion]').forEach(reveal);
  });

  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-pcw-motion]').forEach(reveal);
  });
})();
